import {
  SET_TTS_TEXT_STATE,
  FETCH_TTS_TEXT,
  SET_TTS_UPDATE_DATA,
  UPDATE_TTS_TEXT,
  FETCH_TEST_TTS_TEXT,
  UPDATE_TEST_TTS_TEXT,
} from '../constants/actions'

export const setTTSTextStateAction = (payload) => ({
  type: SET_TTS_TEXT_STATE,
  payload,
})

export const fetchTTSTextAction = (payload) => ({
  type: FETCH_TTS_TEXT,
  payload,
})

export const fetchTestTTSTextAction = (payload) => ({
  type: FETCH_TEST_TTS_TEXT,
  payload,
})

export const setTTSUpdateDataAction = (payload) => ({
  type: SET_TTS_UPDATE_DATA,
  payload,
})

export const updateTTSTextAction = (payload) => ({
  type: UPDATE_TTS_TEXT,
  payload,
})

export const updateTestTTSTextAction = (payload) => ({
  type: UPDATE_TEST_TTS_TEXT,
  payload,
})
